import { Component } from '@angular/core';

@Component({
  selector: 'testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.css']
})

export class TestimonialsComponent {

  customOptions: any = {
    autoplay: true,
    dots: true,
    loop: false,
    items: 1
  };

}
